import { Navigate } from 'react-router-dom';
import { usePrimaryRole } from '@/lib/hooks/useUserRoles';
import { useUser } from '@/lib/auth';

/**
 * Modelo B (Sprint 8): bloquea a Gurus de acceder al panel cliente.
 *
 * Reglas:
 *   - Usuario sin sesión → /login (lo maneja AuthGuard, antes de este)
 *   - role primario 'guru' → redirige a /guru
 *   - 'admin' o 'user' → puede pasar (admin puede ver todo para QA;
 *     cliente puede usar normalmente)
 *
 * Se usa envolviendo el shell de cliente: AuthGuard > ClientGuard > DashboardLayout.
 */
export function ClientGuard({ children }: { children: React.ReactNode }) {
  const user = useUser();
  const role = usePrimaryRole();

  if (!user) return <Navigate to="/login" replace />;
  if (role === null) {
    // Roles cargando todavía — mostrar spinner para no flash al guru hacia dashboard
    return (
      <div className="flex min-h-screen items-center justify-center">
        <div className="h-8 w-8 animate-spin rounded-full border-2 border-brand-accent border-t-transparent" />
      </div>
    );
  }
  if (role === 'guru') {
    return <Navigate to="/guru" replace />;
  }
  return <>{children}</>;
}
